<template>
  <div>  
    <div class="flex">      
    <vs-button :size="size" :key="'we'+bKey" class="px-2 rounded-none" :color="color" type="flat" icon-pack="feather" icon="icon-star" @click="pushButton(!showcasedStatus)">{{ showcasedStatus ? 'Showcase' : 'Showcase' }}</vs-button>
    <vs-dropdown>
                <vs-button class="rounded-none btn-drop w-8" type="flat" color="dark" icon="arrow_drop_down"></vs-button>                
                <vs-dropdown-menu>                                        
                    <vs-dropdown-item class="py-1" v-for="tag in tags" :key="`tw${tag.tag}`" @click="pushButton(false , tag.tag)" v-if="tag.taggedWith">                      
                      <span>
                        <i class="material-icons text-sm inline-block relative icon-down-xs" > check_box </i> {{ tag.tag }}
                      </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item class="py-1" v-for="tag in tags" :key="`ntw${tag.tag}`" @click="pushButton(true , tag.tag)" v-if="!tag.taggedWith">                      
                      <span>
                        <i class="material-icons text-sm inline-block relative icon-down-xs"> check_box_outline_blank </i> {{ tag.tag }}
                      </span>
                    </vs-dropdown-item>                                                                             
                    <vs-dropdown-item :divider="tags.length > 0" class="py-1" @click="optCreateTag" v-if="tags.length < 9">
                      <span class="font-bold">+</span> Add Tag
                    </vs-dropdown-item>
                </vs-dropdown-menu>
      </vs-dropdown>
      </div>
  </div>
</template>

<script>



export default {
  data() {
    return {
      bKey: 1
    }
  },
  props: {
    size: String,
    showcasedStatus: [Boolean, Object],
    payload: Object,
    
    /* 
      data: {
        platform: 'feedback' or 'testimonial', 
        i: //i of JFi
        sessionID: session.sessionID 
        }
      method: Function
      
      OR

      data: { 
          platform: platform, 
          i:i, //i in list of reviews
          reviewDocID: review.reviewDocID 
          }
      method: Function
    */

  },  
  computed: {
    associatedTags () {
      if (this.showcasedStatus) return this.showcasedStatus.taggedWith
      return []
    },
    tags() {
      //returns array of tags - available, and those associated with (if relevant)

      const toReturn = []
      //add current associated tags
      this.associatedTags.forEach((tag) => {
        toReturn.push({
          taggedWith: true,
          tag
        })
      })

      this.$store.state.dash.viewData.currentTags.forEach((tag) => {        
        if (!toReturn.find(el => el.tag === tag)) {
          toReturn.push({
            taggedWith: false,
            tag
          })
        }
      })

      return toReturn

    },
    color() {
      return this.showcasedStatus ? 'primary' : 'light'
    },
  },
  methods: {
    actionCreateTag() {},
    optCreateTag() {      
      this.$store.commit('dash/TOGGLE_SHOW_CREATE_TAG', this.pushButton)      
    },
    pushButton(intent, tag = false) {

      if (tag) tag = tag.trim()
      let ref = this.payload.data.platform === 'feedback' || this.payload.data.platform === 'testimonial'   ? this.payload.data.sessionID : this.payload.data.reviewDocID;
      this.bKey++;

      console.log(this.payload.data.platform, this.payload.data.i, ref, tag, intent, this.associatedTags)

      this.payload.method(this.payload.data.platform, this.payload.data.i, ref, tag, intent, this.associatedTags)

    }
  }
}

</script>


<style lang="scss">

</style>
